import getCurrentUser from './getCurrentUser'

const getCurrentUserId = () => {
  const currentUser = getCurrentUser()

  return currentUser ? currentUser.id : null
}

export default getCurrentUserId
